import React from 'react';
import "./companiesAdd.css"
import CompaniesInputs from './inputs/companiesInputs';

const CompaniesAdd = (props) => {
    return ( 
        <>
            <div className="mainCompaniesList">
                <h1 className="companiesTitle">Dodaj firmę</h1>
                <CompaniesInputs
                    actualCompanyName = {props.actualCompanyName}
                    actualCompanyTemplateID = {props.actualCompanyTemplateID }
                    actualCompanyFolderID = {props.actualCompanyFolderID }
                    handleActualCompanyNameChange = {props.handleActualCompanyNameChange}
                    handleActualCompanyTemplateIDChange = {props.handleActualCompanyTemplateIDChange}
                    handleActualCompanyFolderIDChange = {props.handleActualCompanyFolderIDChange}
                    handleAddCompany = {props.handleAddCompany}
                />
            </div>
        </>
     );
}
 
export default CompaniesAdd;